const ZENDESK_SCRIPT_ID = "ze-snippet";

export const initializeZendeskChat = ({
  apiKey,
  hide = false, // this is for landing page that should not have chat widget
}) => {
  let initScript = document.getElementById(ZENDESK_SCRIPT_ID);

  if (apiKey && !initScript) {
    initScript = document.createElement("script");
    initScript.async = true;
    initScript.setAttribute("id", ZENDESK_SCRIPT_ID);
    initScript.setAttribute(
      "src",
      `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`
    );
    initScript.addEventListener("load", () => {
      const configScript = document.createElement("script");
      configScript.async = true;
      configScript.innerHTML = `
      window.zESettings = {
        messenger: {
          launcher: {
            chatLabel: {
              '*': ' '
            }
          },
          zIndex: 1000
        }
      };
      zE(function () {
        
        
        setTimeout(() => {
          zE("messenger", "open");
          zE("messenger", "close");
          if (${hide}) {
            zE("messenger", "hide");
          }
        }, 300);
        
      });`;
      document.body.appendChild(configScript);
    });
    document.body.appendChild(initScript);
  }
};

export const hideZendeskChat = () =>
  window.zE && window.zE("messenger", "hide");
export const showZendeskChat = () =>
  window.zE && window.zE("messenger", "show");
